import { SceneContextMenuBase } from "@/components/ui/scene-context-menu";
import { removeAnalysisLabel } from "@/store/point-cloud-analysis-tool-slice";
import { useAppDispatch } from "@/store/store-hooks";
import { FaroMenuItem } from "@faro-lotv/flat-ui";
import { Box } from "@mui/material";
import { RefObject, useCallback, useRef, type JSX } from "react";
import { Vector3 } from "three";
import { AppAwareHtml } from "../app-aware-html";

type AnalysisLabelMenuProps = {
  /** 3D position of the label menu in the scene */
  position: Vector3;

  /** The parent that the label menu should have in the html DOM */
  parentRef: RefObject<HTMLElement>;

  /** Function close this menu */
  closeMenu(): void;

  /** The id of the analysis associated with this menu */
  analysisId: string;

  /** The id of the label associated with this menu */
  labelId: string;
};

/**
 * @returns A menu that appears when an analysis label is clicked.
 */
export function AnalysisLabelMenu({
  position,
  parentRef,
  analysisId,
  labelId,
  closeMenu,
}: AnalysisLabelMenuProps): JSX.Element {
  const dispatch = useAppDispatch();

  const deleteLabel = useCallback(() => {
    dispatch(removeAnalysisLabel({ analysisId, labelId }));
    closeMenu();
  }, [dispatch, analysisId, labelId, closeMenu]);

  const anchorEl = useRef(null);
  return (
    <AppAwareHtml
      position={position}
      portal={parentRef}
      style={{
        display: "block",
      }}
      zIndexRange={[0, 0]}
    >
      {/* Create a empty box as anchor for the popup menu */}
      <Box component="div" ref={anchorEl} />
      <SceneContextMenuBase anchorEl={anchorEl.current} onClose={closeMenu}>
        <FaroMenuItem dark label="Delete" onClick={deleteLabel} />
      </SceneContextMenuBase>
    </AppAwareHtml>
  );
}
